module.exports = __webpack_public_path__ + "img/yurtici.1ab068d2.png";